import request from '@/utils/request.js'

const payApi = process.env.VUE_APP_PAY_API
const purchaseApi = process.env.VUE_APP_PURCHASE_API
const biddingDogApi = process.env.VUE_APP_BIDDOG_API

// 增值服务下单
export function payValueAddedServiceApi(data) {
  return request({
    url: payApi + '/avs/order/pay',
    method: 'post',
    data
  })
}

// 查询增值服务支付状态
export function queryValueAddedServicePayStatusApi(payCode) {
  return request({
    url: payApi + `/avs/order/${payCode}/pay-status`,
    method: 'get'
  })
}

// 查询增值服务订单
export function queryValueAddedServicePayHistoryApi(params) {
  return request({
    url: payApi + '/avs/order/record/page',
    method: 'get',
    params
  })
}

// 根据产品编号查询产品权益
export function queryValueAddedServiceProductRightsApi(productCode) {
  return request({
    url: payApi + `/avs/products/${productCode}/rights`,
    method: 'get'
  })
}

// 根据产品分类编号查询产品权益
export function queryValueAddedServiceCategoryRightsApi(categoryCode) {
  return request({
    url: payApi + `/avs/product-category/${categoryCode}/rights`,
    method: 'get'
  })
}

// 根据产品编号查询账户余额(仅针对次数扣费类产品， 如标书预览次数、数字CA抵扣券)
export function queryValueAddedServiceAccountBalanceApi(productCode) {
  return request({
    url: payApi + `/avs/product/${productCode}/account/remain`,
    method: 'get'
  })
}

// 根据产品编号查询sku(产品套餐)
export function querySkuByValueAddedServiceApi(productCode) {
  return request({
    url: payApi + `/avs/products/${productCode}/skus`,
    method: 'get'
  })
}

// 根据产品分类编号查询sku(产品套餐)
export function querySkuByValueAddedServiceCategoryApi(categoryCode) {
  return request({
    url: payApi + `/avs/product-category/${categoryCode}/skus`,
    method: 'get'
  })
}

/** **************** 标书预览增值服务相关接口 **********************/
// 查询购买的标书预览服务列表
export function queryBidFilePreviewServiceListApi(params) {
  return request({
    url: purchaseApi + '/workbench/user/avs/orders/page',
    method: 'get',
    params: params
  })
}

// 查询标书预览服务信息
export function queryBidFilePreviewServiceApi(orderId) {
  return request({
    url:
      purchaseApi + `/workbench/v2/avs/bidding-orders/${orderId}/preview-files`,
    method: 'get'
  })
}

// 查询标书预览余额
export function queryBidFilePreviewBalanceApi() {
  return request({
    url: purchaseApi + `/workbench/v2/avs/bidding-orders/preview-remain`,
    method: 'get'
  })
}

/** ********************* 增值服务-数据定制导出相关接口 ********************************/
// 根据业务编号查询OSS文件路径
export function getCustomDataExportURLApi(bizCode) {
  return request({
    url: biddingDogApi + `/biddog/findNoticeOssPatByBizCode/${bizCode}`,
    method: 'get'
  })
}

// 分页查询数据定制导出历史列表
export function getCustomDataExportHistoryApi(params) {
  return request({
    url: biddingDogApi + '/biddog/noticeExportTask/page',
    method: 'get',
    params
  })
}

// 数据定制导出失败后，重新生成新的导出编号
export function downloadCustomDataAgainApi(bizCode) {
  return request({
    url: biddingDogApi + `/biddog/generateNoticeExport/${bizCode}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询画像查看记录
export function getPortraitRecordApi(params) {
  return request({
    url: biddingDogApi + '/analysis/company/portrait/paid/record/page',
    method: 'get',
    params
  })
}

export function getCompanyApi(params) {
  return request(
    {
      url: biddingDogApi + `/mark/companies/page`,
      method: 'get',
      params
    },
    { needLoading: false }
  )
}

// 分页查询企业列表
export function getFollowedCompanyPageApi(params) {
  return request({
    url: biddingDogApi + '/biddog/follow/company/page',
    method: 'get',
    params
  })
}

// 分页查询项目
export function getFollowedProjectPageApi(params) {
  return request({
    url: biddingDogApi + '/biddog/follow/purchase/page',
    method: 'get',
    params
  })
}

// 获取最新的订阅配置
export function getLastSubscribeConfigApi() {
  return request({
    url: biddingDogApi + '/subscribes/latest'
  })
}

// 分页查询订阅消息列表
export function getSubscribeListApi(params) {
  return request({
    url: biddingDogApi + '/subscribes/latest/messages/page',
    method: 'get',
    params
  })
}
